import React, {useEffect} from 'react';
import 'aos/dist/aos.css'
import './styles.css'
import AOS from 'aos';
import AuthProvider from './authContext';
import AppWrapper from './Containers/AppWrapper'

function App() {
  useEffect(() =>
  {
    const reduceMotion = typeof window !== "undefined" &&
      window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

    AOS.init({
      duration: 600,
      debounceDelay: 100,
      disable: reduceMotion,
      mirror: false,
      easing: "ease",
      once: true,
      offset: 35
    });
    
  }, [])
  return (
    <div className="app">
      <AuthProvider>
        <AppWrapper />
      </AuthProvider>
    </div>
  );
}

export default App;
